export const DOMAINS_TABLE_HEADERS = [
  { label: "Domain", key: "domain", width: 5 },
  { label: "Forward to URL", key: "forwardToURL", width: 5 },
  { label: "Mailboxes", key: "mailboxes", width: 4 },
  { label: "Status", key: "status", width: 3 },
  { label: "Created on", key: "createdAt", width: 4 },
];

export const LOADING_TIMEOUT = 10000;

export const DOMAIN_STATUS = {
  UNKNOWN: "Unknown",
  ERROR: "Error",
};

export const DEFAULT_VALUES = {
  UNKNOWN_DOMAIN: "unknown-domain.com",
  ERROR_DOMAIN: "error-domain.com",
  EMPTY_FORWARD: "-",
  UNKNOWN_DATE: "Unknown date",
};
